/**
 * Número de elementos por página en la tabla
 */
export const ITEMS_PER_PAGE = 10;

/**
 * Estado inicial de sucursal
 */
export const INITIAL_BRANCH_STATE = {
  uuid: null,
  uuid_company: '',
  description: '',
  adress: '',
  gps_cords: '',
  city: '',
  province: '',
  country: '',
  postal_code: '',
  email: '',
  telephone: '',
  timezone: 'UTC -3',
};

/**
 * Mensajes del sistema
 */
export const MESSAGES = {
  SUCCESS: {
    CREATE: 'Sucursal creada exitosamente',
    UPDATE: 'Sucursal actualizada exitosamente',
    DELETE: 'Sucursal eliminada exitosamente',
  },
  ERROR: {
    CREATE: 'Error al crear la sucursal',
    UPDATE: 'Error al actualizar la sucursal',
    DELETE: 'Error al eliminar la sucursal',
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_EMAIL: 'Email inválido',
    INVALID_PHONE: 'Teléfono inválido',
  },
};

/**
 * Configuración de columnas de la tabla
 */
export const TABLE_COLUMNS = {
  description: { width: '20%' },
  adress: { width: '20%' },
  city: { width: '20%' },
  province: { width: '20%' },
  actions: { width: '20%' },
};
